import axiosIns from "@/api/axios";
import querystring from "query-string";

export const GET_DATA_LIST = (params) => {
    return axiosIns.get(`/role-mapping?${params}`);
};

export const GET_DATA_USER = (params) => {
    return axiosIns.get(`/users/search?${params}`);
};

export const GET_ROLES = (params) => {
    return axiosIns.get(`/roles`);
};

export const GET_IDENTIFY = (params) => {
    return axiosIns.get(`/users/identify`);
};

export const CREATE_DATA = (body) => {
    return axiosIns.post('/role-mapping/create', body);
};

export const DELETE_ROLEMANAGEMENT = (id) => {
    return axiosIns.put(`/role-mapping/${id}/delete`);
};

export const UPDATE_ROLEMANAGEMENT = (id) => {
    return axiosIns.put(`/role-mapping/update`, id);
};

export const DELETE_DATA = (id) => {
    return axiosIns.delete(`/capex-gl/${id}`);
};

export const UPDATE_DATA = (body) => {
    return axiosIns.put(`/capex-gl/${body.id}`, body.body);
};

export const SHARE_BUDGET_PLAN = (body) => {
    return axiosIns.post(`/access`, body);
};
export const UNSHARE_BUDGET_PLAN = (id) => {
    return axiosIns.delete(`/access/${id}`);
};

export const GET_ROLES_LIST = () => {
    return axiosIns.get(`/roles/list`);
};
export const GET_MENU_LIST = () => {
    return axiosIns.get(`/master-role/menu`);
};
export const GET_MENU_LIST_ALL = () => {
    return axiosIns.get(`/master-role`);
};